<template>
  <div class="modal-dialog" role="document">
    <span class="center-text">
      <b-spinner label="Spinning" class="mr-3"></b-spinner>
      Loading
      <b-spinner class="dot-loading one-dot mr-2" type="grow" label="Spinning"></b-spinner>
      <b-spinner class="dot-loading two-dot mr-2" type="grow" label="Spinning"></b-spinner>
      <b-spinner class="dot-loading three-dot" type="grow" label="Spinning"></b-spinner>
    </span>
  </div>
</template>

<script>
export default {
  name: "Loading"
}
</script>

<style scoped>
.modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: block;
  position: absolute;
  z-index: 100000;
  background-color: lightgrey;
  opacity: 0.7
}
.center-text{
  position: relative;
  top: 50%;
  left: 50%;
}
.dot-loading{
  width: 8px;
  height: 8px;
}
.one-dot{
  animation-delay: 0.2s;
}
.two-dot{
  animation-delay: 0.3s;
}
.three-dot{
  animation-delay: 0.4s;
}
</style>
